// Sidebar.js
import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';

const Sidebar = ({ activeSection, setActiveSection }) => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const menuItems = [
        { icon: '🔗', title: 'Edit Links', label: "Links" },
        { icon: '🎨', title: 'Browse Templates', label: "Templates" },
    ];

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    return (
        <>
            {/* Mobile Menu Button */}
            <button 
                onClick={toggleMobileMenu}
                className="lg:hidden fixed top-4 right-4 z-50 p-2 rounded-lg bg-white shadow-lg"
                aria-label="Toggle menu"
            >
                {isMobileMenuOpen ? (
                    <X className="w-6 h-6 text-gray-600" />
                ) : (
                    <Menu className="w-6 h-6 text-gray-600" />
                )}
            </button>

            {/* Overlay for mobile */}
            {isMobileMenuOpen && (
                <div 
                    className="lg:hidden fixed inset-0 bg-black bg-opacity-50 z-30"
                    onClick={toggleMobileMenu}
                />
            )}

            {/* Sidebar */}
            <aside 
                className={`
                    ${isMobileMenuOpen ? 'translate-x-0' : '-translate-x-full'} 
                    lg:translate-x-0
                    fixed top-0 left-0 h-screen z-40
                    w-64 lg:w-1/6
                    bg-white border-r border-gray-200 
                    transition-transform duration-300 ease-in-out
                    flex flex-col
                `}
            >
                <div className="p-4">
                    <div className="flex items-center space-x-3">
                        <div className="text-sm font-semibold text-gray-800">Your spelltree</div>
                    </div>
                </div>

                <nav className="flex-1 overflow-y-auto">
                    {menuItems.map((item, index) => (
                        <button
                            key={index}
                            onClick={() => {
                                setActiveSection(item.label);
                                setIsMobileMenuOpen(false); // Close mobile menu when item is selected
                            }}
                            className={`flex items-center space-x-3 px-4 py-3 w-full text-sm ${
                                activeSection === item.label
                                    ? 'bg-purple-100 text-purple-600'
                                    : 'text-gray-600 hover:bg-gray-100'
                            }`}
                        >
                            <span>{item.icon}</span>
                            <span>{item.label}</span>
                        </button>
                    ))}
                </nav>

                <div className="p-4 border-t border-gray-200">
                    <button className="w-full py-2 px-4 bg-gray-100 text-gray-600 rounded text-sm font-medium hover:bg-gray-200 transition-colors">
                        🌐 Try Pro for free
                    </button>
                </div>
            </aside>

            {/* Content margin for desktop */}
            {/* <div className="hidden lg:block w-1/6" /> */}
        </>
    );
};

export default Sidebar;